// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo__root--Trd_ {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
}

    .Logo__root--Trd_ img {
        width: 128px;
        height: 32px;
    }

    @media screen and (min-width: 1024px) {
        .Logo__root--Trd_ img {
            width: 160px;
            height: 40px;
        }
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AAad;;IAXI;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI;YACI,YAAY;YACZ,YAAY;QAChB;IACJ","sourcesContent":[".root {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n\n    & img {\n        width: 128px;\n        height: 32px;\n    }\n\n    @media (--large) {\n        & img {\n            width: 160px;\n            height: 40px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Logo__root--Trd_`
};
export default ___CSS_LOADER_EXPORT___;
